export const setModalOpen = '@questionPrompt/setModalOpen';
export const setModalType = '@questionPrompt/setModalType';
export const setItems = '@questionPrompt/setItems';
export const setSelectedItem = '@questionPrompt/setSelectedItem';
export const setTemplateType = '@questionPrompt/setTemplateType';
export const setCurrentPage = '@questionPrompt/setCurrentPage';
export const setItemsPerPage = '@questionPrompt/setItemsPerPage';
export const setPaginationMeta = '@questionPrompt/setPaginationMeta';
export const setReload = '@questionPrompt/setReload';
export const setIsLoading = '@questionPrompt/setIsLoading';
